import React, { useState } from 'react';
import { Box, Container, Typography, Grid, Paper, useTheme, useMediaQuery, Dialog, DialogContent, IconButton, Button, GlobalStyles } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';

// Íconos
import SchoolIcon from '@mui/icons-material/School';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BoltIcon from '@mui/icons-material/Bolt';
import GroupsIcon from '@mui/icons-material/Groups';
import ComputerIcon from '@mui/icons-material/Computer';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const getBentoItems = (activeTab) => [
  {
    title: 'Muro de la Comunidad',
    subtitle: activeTab === 0 ? 'Encuentra aliados estratégicos B2B.' : 'Conecta, colabora y hazte notar.',
    description: activeTab === 0 
      ? 'La Comunidad Hitpoly es el corazón del ecosistema. Publica las necesidades de tu empresa, encuentra agencias o profesionales para proyectos puntuales, y mantente al día con las últimas estrategias de crecimiento en tu industria.'
      : 'Un espacio dinámico para compartir tu conocimiento. Interactúa con empresas, resuelve dudas, gana reputación como experto en tu área y atrae oportunidades laborales sin tener que enviar currículums fríos.',
    icon: GroupsIcon,
    color: '#1877F2',
    colSpan: { xs: 12, md: 8 },
    gradient: 'linear-gradient(135deg, #1877F2 0%, #0d5bbd 100%)',
    features: activeTab === 0 ? ['Networking B2B', 'Búsqueda de talento', 'Publicación de proyectos'] : ['Foros de discusión', 'Marca personal', 'Colaboración abierta']
  },
  {
    title: 'Academia HitPoly',
    subtitle: activeTab === 0 ? 'Capacita a tu equipo interno.' : 'Aprende habilidades rentables.',
    description: activeTab === 0 
      ? 'Accede a formaciones para tu equipo de ventas y marketing. Aprende sobre embudos, automatización e Inteligencia Artificial aplicada a los negocios, y mantén a tu empresa siempre un paso adelante.'
      : 'Accede a módulos de formación especializados en habilidades digitales de alta demanda. Aprende a tu propio ritmo con certificaciones avaladas y aplica tus conocimientos directamente ofreciendo servicios en la Bolsa de Profesionales.',
    icon: SchoolIcon,
    color: '#6C4DE2',
    colSpan: { xs: 12, md: 4 },
    gradient: 'linear-gradient(135deg, #6C4DE2 0%, #4b32a3 100%)',
    features: activeTab === 0 ? ['Capacitación corporativa', 'Métricas de progreso', 'Soporte especializado'] : ['Cursos certificados', 'Mentores expertos', 'Acceso de por vida']
  },
  {
    title: 'Lead Scraping',
    subtitle: activeTab === 0 ? 'Extrae prospectos B2B en segundos.' : 'Ofrece servicios de prospección.',
    description: activeTab === 0
      ? 'Potencia tus ventas con nuestra herramienta de extracción de datos. Encuentra clientes potenciales de cualquier nicho, obtén correos y teléfonos validados, y expórtalos automáticamente a tu CRM.'
      : 'Aprende a usar la herramienta y ofrece el servicio de "Generación de Leads" a las empresas del ecosistema. Conviértete en un prospector indispensable utilizando nuestra tecnología.',
    icon: TravelExploreIcon,
    color: '#E67E22',
    colSpan: { xs: 12, md: 4 },
    gradient: 'linear-gradient(135deg, #E67E22 0%, #ba5d11 100%)',
    features: activeTab === 0 ? ['Búsqueda por nicho', 'Datos validados', 'Exportación a CRM'] : ['Servicio escalable', 'Datos en tiempo real', 'Alta demanda']
  },
  {
    title: 'Formark CRM',
    subtitle: activeTab === 0 ? 'Cierra más ventas, más rápido.' : 'Gestiona tus clientes freelance.',
    description: activeTab === 0 
      ? 'Un CRM diseñado para escalar. Segmenta tu embudo de ventas, automatiza seguimientos, gestiona comunicaciones y analiza el crecimiento de tu empresa con métricas precisas.'
      : 'Usa el CRM de Hitpoly para organizar a los clientes que consigas. Mantén un registro de tus comunicaciones, facturas pendientes y proyectos entregados de manera profesional.',
    icon: BusinessCenterIcon,
    color: '#3B207F',
    colSpan: { xs: 12, md: 4 },
    gradient: 'linear-gradient(135deg, #3B207F 0%, #220f52 100%)',
    features: activeTab === 0 ? ['Embudos visuales', 'Automatizaciones', 'Métricas y reportes'] : ['Gestión de clientes', 'Organización de proyectos', 'Seguimiento visual']
  },
  {
    title: 'Gestión de Proyectos',
    subtitle: activeTab === 0 ? 'Organiza y delega con éxito.' : 'Controla tus entregas a tiempo.',
    description: activeTab === 0 
      ? 'Mantén a tu equipo alineado. HitProyect te permite crear tableros Kanban, asignar tareas, establecer fechas límite y compartir archivos de forma colaborativa.'
      : 'Demuestra profesionalismo frente a las empresas. Usa el sistema Kanban para mostrar el progreso de tu trabajo, solicitar feedback y entregar resultados sin fricciones.',
    icon: AssignmentIcon,
    color: '#FF6B35',
    colSpan: { xs: 12, md: 4 },
    gradient: 'linear-gradient(135deg, #FF6B35 0%, #c94c20 100%)',
    features: ['Tableros Kanban', 'Asignación de tareas', 'Control de tiempo']
  },
  {
    title: 'Bolsa de Profesionales',
    subtitle: activeTab === 0 ? 'Contrata talento global verificado.' : 'Consigue trabajo de alto valor.',
    description: activeTab === 0
      ? 'Encuentra a los mejores profesionales formados en nuestra academia. Filtra por habilidades, revisa sus portafolios y contrata perfiles altamente capacitados para tu empresa sin intermediarios.'
      : 'El escaparate principal para tu talento. Sube tu portafolio, aplica a proyectos publicados por las empresas o permite que te contacten directamente gracias a la visibilidad del ecosistema.',
    icon: BoltIcon,
    color: '#00A86B',
    colSpan: { xs: 12, md: 5 },
    gradient: 'linear-gradient(135deg, #00A86B 0%, #007a4e 100%)',
    features: activeTab === 0 ? ['Talento verificado', 'Contratación directa', 'Filtros avanzados'] : ['Aplicación directa', 'Portafolios integrados', 'Alta visibilidad']
  },
  {
    title: 'Mensajes y Chat',
    subtitle: activeTab === 0 ? 'Comunícate con tu equipo.' : 'Negocia directamente.',
    description: activeTab === 0 
      ? 'Chat integrado y seguro para coordinar con tu equipo interno o hablar directamente con los profesionales que has contratado. Mantén todo el historial protegido.'
      : 'Responde rápidamente a ofertas de trabajo, negocia términos y mantén comunicación fluida con las empresas sin tener que dar tu número personal.',
    icon: IntegrationInstructionsIcon,
    color: '#F21C63',
    colSpan: { xs: 12, md: 3 },
    gradient: 'linear-gradient(135deg, #F21C63 0%, #b81047 100%)',
    features: ['Chat B2B seguro', 'Grupos de trabajo', 'Envío de archivos']
  },
  {
    title: 'Gestión RRSS',
    subtitle: activeTab === 0 ? 'Todo tu social media centralizado.' : 'Gestiona marcas como Community.',
    description: activeTab === 0 
      ? 'Planifica, programa y publica contenido en todas tus redes sociales desde un único panel. Analiza el rendimiento y maneja la estrategia digital de tu marca.'
      : 'Si eres Community Manager, utiliza esta herramienta premium para gestionar las cuentas de tus clientes desde un solo lugar, programando posts y entregando reportes de métricas.',
    icon: ComputerIcon,
    color: '#29B6F6',
    colSpan: { xs: 12, md: 4 },
    gradient: 'linear-gradient(135deg, #29B6F6 0%, #158dbf 100%)',
    features: ['Programación de posts', 'Analíticas cruzadas', 'Multi-cuentas']
  }
];

const EcosystemBentoGrid = ({ activeTab }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedItem, setSelectedItem] = useState(null);

  const currentItems = getBentoItems(activeTab);

  return (
    <Box id="ecosystem-features" sx={{ background: '#0B0914', py: 10, color: '#fff' }}>
      
      {/* Forzar ocultamiento del scroll principal cuando el popup está abierto */}
      {selectedItem && (
        <GlobalStyles 
          styles={{ 
            'html, body': { overflow: 'hidden !important', touchAction: 'none' },
            '#root': { overflow: 'hidden !important' }
          }} 
        />
      )}

      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <Typography variant="h3" fontWeight={800} mb={2}>
                Una plataforma,{' '}
                <Box component="span" sx={{ color: activeTab === 0 ? '#F21C63' : '#29B6F6', transition: 'color 0.5s ease' }}>
                  infinitas posibilidades
                </Box>
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', maxWidth: 600, mx: 'auto' }}>
                {activeTab === 0 
                  ? 'Cada herramienta está diseñada para optimizar los procesos de tu empresa, desde la captación hasta la operación diaria.'
                  : 'Cada herramienta está conectada para potenciar tu carrera, desde la formación hasta conseguir tus primeros clientes de alto valor.'}
              </Typography>
            </motion.div>
          </AnimatePresence>
        </Box>

        {/* BENTO GRID PERFECTO (3 Filas, 12 columnas cada una) */}
        <Grid container spacing={3}>
          {currentItems.map((item, index) => (
            <Grid 
              item 
              xs={item.colSpan.xs} 
              md={item.colSpan.md} 
              key={index}
              sx={{ display: 'flex' }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                style={{ width: '100%', display: 'flex' }}
                onClick={() => setSelectedItem(item)}
              >
                <Paper
                  elevation={0}
                  sx={{
                    width: '100%',
                    p: 4,
                    borderRadius: '24px',
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    position: 'relative',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease, border-color 0.3s ease',
                    minHeight: '240px',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      borderColor: 'rgba(255,255,255,0.2)',
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: item.gradient,
                      opacity: 0,
                      transition: 'opacity 0.3s ease',
                      zIndex: 0,
                    },
                    '&:hover::before': {
                      opacity: 0.15,
                    }
                  }}
                >
                  <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: `rgba(${parseInt(item.color.slice(1, 3), 16)}, ${parseInt(item.color.slice(3, 5), 16)}, ${parseInt(item.color.slice(5, 7), 16)}, 0.2)`,
                        color: item.color,
                        mb: 3,
                      }}
                    >
                      <item.icon fontSize="large" />
                    </Box>
                    <Typography variant="h5" fontWeight={700} mb={1}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', flexGrow: 1 }}>
                      {item.subtitle}
                    </Typography>

                    <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', color: item.color, fontWeight: 'bold', fontSize: '0.9rem' }}>
                      Ver detalles <ArrowForwardIcon sx={{ ml: 0.5, fontSize: 16 }} />
                    </Box>
                  </Box>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* POPUP DE DETALLES FULLSCREEN */}
      <Dialog
        open={Boolean(selectedItem)}
        onClose={() => setSelectedItem(null)}
        fullScreen
        sx={{ zIndex: 200000 }} // Mayor que el zIndex del menú de navegación
        PaperProps={{
          sx: {
            background: '#13111C',
            color: '#fff',
            borderRadius: 0,
            border: 'none',
            backgroundImage: 'none',
            overflowY: 'auto',
            overflowX: 'hidden',
            // Estilos de Scroll fino
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(255,255,255,0.02)',
            },
            '&::-webkit-scrollbar-thumb': {
              background: selectedItem ? selectedItem.color : 'rgba(255,255,255,0.2)',
              borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: selectedItem ? selectedItem.color : 'rgba(255,255,255,0.3)',
            },
          }
        }}
      >
        <AnimatePresence>
          {selectedItem && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '40vh',
                  background: selectedItem.gradient,
                  opacity: 0.15,
                  zIndex: 0,
                  maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
                  WebkitMaskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)'
                }}
              />
              
              <IconButton
                onClick={() => setSelectedItem(null)}
                sx={{ 
                  position: 'fixed', 
                  top: { xs: 16, md: 32 }, 
                  right: { xs: 16, md: 32 }, 
                  color: '#fff', 
                  zIndex: 10,
                  background: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(10px)',
                  '&:hover': { background: 'rgba(255,255,255,0.2)' }
                }}
              >
                <CloseIcon fontSize="large" />
              </IconButton>
              
              <DialogContent sx={{ p: { xs: 3, md: 8 }, pt: { xs: 12, md: 12 }, position: 'relative', zIndex: 1, flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                <Container maxWidth="md">
                  <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }} gap={4} mb={6}>
                    <Box
                      sx={{
                        width: { xs: 80, md: 100 },
                        height: { xs: 80, md: 100 },
                        borderRadius: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: `rgba(${parseInt(selectedItem.color.slice(1, 3), 16)}, ${parseInt(selectedItem.color.slice(3, 5), 16)}, ${parseInt(selectedItem.color.slice(5, 7), 16)}, 0.2)`,
                        color: selectedItem.color,
                        boxShadow: `0 10px 30px rgba(${parseInt(selectedItem.color.slice(1, 3), 16)}, ${parseInt(selectedItem.color.slice(3, 5), 16)}, ${parseInt(selectedItem.color.slice(5, 7), 16)}, 0.3)`,
                      }}
                    >
                      <selectedItem.icon sx={{ fontSize: { xs: 40, md: 50 } }} />
                    </Box>
                    <Box>
                      <Typography variant="h3" fontWeight={800} mb={1}>{selectedItem.title}</Typography>
                      <Typography variant="h5" color="rgba(255,255,255,0.7)">{selectedItem.subtitle}</Typography>
                    </Box>
                  </Box>

                  <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.2rem', lineHeight: 1.8, mb: 6 }}>
                    {selectedItem.description}
                  </Typography>

                  <Typography variant="h5" fontWeight={700} mb={3}>Características Principales:</Typography>
                  <Grid container spacing={3} mb={8}>
                    {selectedItem.features.map((feat, idx) => (
                      <Grid item xs={12} sm={4} key={idx}>
                        <Box sx={{ p: 3, borderRadius: '16px', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', height: '100%' }}>
                          <Typography variant="body1" fontWeight="bold">{feat}</Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>

                  <Box textAlign="center" mt={2} mb={4}>
                    <Button
                      variant="outlined"
                      size="large"
                      sx={{
                        borderColor: selectedItem.color,
                        color: '#fff',
                        px: 6,
                        py: 1.5,
                        borderRadius: '50px',
                        textTransform: 'none',
                        fontWeight: 'bold',
                        fontSize: '1.1rem',
                        '&:hover': {
                          background: `rgba(${parseInt(selectedItem.color.slice(1, 3), 16)}, ${parseInt(selectedItem.color.slice(3, 5), 16)}, ${parseInt(selectedItem.color.slice(5, 7), 16)}, 0.1)`,
                          borderColor: selectedItem.color
                        }
                      }}
                      onClick={() => {
                        setSelectedItem(null);
                      }}
                    >
                      Cerrar y seguir explorando
                    </Button>
                  </Box>
                </Container>
              </DialogContent>
            </motion.div>
          )}
        </AnimatePresence>
      </Dialog>
    </Box>
  );
};

export default EcosystemBentoGrid;
